const FRONTEND_URL: string | undefined = process.env.REACT_APP_FRONTEND_URL;
const BACKEND_URL: string | undefined = process.env.REACT_APP_BACKEND_URL;
const HACKER_URL: string | undefined = process.env.REACT_APP_HACKER_URL;
const SENTRY_DSN: string | undefined = process.env.REACT_APP_SENTRY_DSN;
const ENV: string | undefined = process.env.REACT_APP_ENV;

export { FRONTEND_URL, BACKEND_URL, HACKER_URL, SENTRY_DSN, ENV };
